import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseElement } from '../base-element';
import { FormEvent } from '../../../crud/form/form-event.enum';

@Component({
  selector: 'input-base-prepend',
  templateUrl: './base-input-prepend.component.html',
  styles: [
    '.form-group.inline-group .invalid-feedback { left: 0; }'
  ],
  providers: [ {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => BaseInputPrependComponent),
    multi: true
  } ]
})
export class BaseInputPrependComponent extends BaseElement<string> implements OnInit {

  @Input() type = 'text';
  @Input() placeholder: string;

  error = '';

  ngOnInit(): void {
    if (this.channel) {
      this.channel.subscribe((event: FormEvent) => {
        if (event === FormEvent.SUBMIT) {
          if (this.form.controls[this.formControlName].invalid) {
            this.toggleInvalidClass(true);
            this.renderErrors();
          } else {
            this.toggleInvalidClass(false);
          }
        }
      });
    }
  }

  onChange($event): void {
    this.error = '';
    this.toggleInvalidClass(false);
    if (this.change) {
      this.change.emit(this.form.controls[this.formControlName].value);
    }

  }

  onKeyup($event): void {
    if (this.keyupEvent) {
      this.keyupEvent.emit($event);

    }
  }

  protected toggleInvalidClass(flag: boolean): void {
    this.customClass = Object.assign(this.customClass, { 'is-invalid': flag });
  }

  protected renderErrors(): void {
    this.error = '';
    if (!this.errorMessages) {
      return;
    }

    if (typeof this.errorMessages === 'string') {
      this.error = this.errorMessages;
    } else {
      const errors = this.form.controls[this.formControlName].errors;
      for (const validator of Object.keys(errors)) {
        if (errors[validator]) {
          this.error += this.errorMessages[validator] + '<br />';
        }
      }
    }
  }
}
